import { TOKEN_LOADED } from '../actions/tokenActions'

export function authTokenReducer(state = null, action) {
  switch (action.type) {
    case TOKEN_LOADED:
      return action.tokens
    default:
      return state
  }
}